const mockData =  {
  "coord": {
    "lon": 13.39,
    "lat": 52.52
  },
  "weather": [{
    "id": "ABC",
    "main": "Clear",
    "description": "clear sky",
    "icon": "01d"
  }],
  "base": "stations",
  "main": {
    "temp": 285.64,
    "pressure": 1019,
    "humidity": 43,
    "temp_min": 285.15,
    "temp_max": 286.15
  },
  "visibility": 10000,
  "wind": {
    "speed": 3.1,
    "deg": 200
  },
  "clouds": {
    "all": 0
  },
  "dt": 1540995600,
  "sys": {
    "type": 1,
    "id": 4892,
    "message": 0.003,
    "country": "DE",
    "sunrise": 1540965701,
    "sunset": 1541000253
  },
  "id": 2950159,
  "name": "Berlin",
  "cod": 200
};

export default mockData;